'use client';

import { useJobs } from '@gate-js/react';

export default function GateJobListNonEmptyWrapper({ children, placeholder }) {
	const { jobs } = useJobs();

	if (!jobs) {
		return null;
	}
	return (jobs.length > 0) ? (
		children
	) : <p>{placeholder}</p>;
}
